// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C9-gY","col":"styles_col__WvZ8Z","actions":"styles_actions__12pdz","conflict":"styles_conflict__1JTQS"};